module.exports = __webpack_public_path__ + "img/sec-16-sk.b784c08f.svg";